import JitsiMeetJS, { JitsiLocalTrack } from 'lib-jitsi-meet'

import WatchRTC from './watchRTC/WatchRTC'

export function initJitsi() {
  JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR)
  WatchRTC.init(window.config)
  return JitsiMeetJS.init(window.config)
}

export function createLocalTracks(
  options?: Parameters<typeof JitsiMeetJS.createLocalTracks>[0]
): Promise<JitsiLocalTrack[]> {
  return JitsiMeetJS.createLocalTracks(options)
}
